import { File, FileImage, FileSpreadsheet, FileText, Film, Music, Presentation, type LucideIcon } from 'lucide-react'
import type { AttachmentKind } from '@numeo/types-core'

/**
 * How admin DRAWS a file kind. What a file is, is `attachmentKindOf` in `@numeo/types`, beside the
 * document formats it reuses — this is only the lucide icon and the word for it.
 *
 * Split that way because the classification is the part other clients need and the part that must
 * not fork again, while the look is exactly what each surface disagrees about: DQF paints a soft
 * badge behind the icon, an SMS chip tints the glyph inside a bubble already coloured by who sent
 * the message, and the two older MUI email lists carry their own icon set entirely.
 */
export const FILE_KIND_ICON: Record<AttachmentKind, LucideIcon> = {
    image: FileImage,
    audio: Music,
    video: Film,
    pdf: FileText,
    word: FileText,
    spreadsheet: FileSpreadsheet,
    presentation: Presentation,
    text: FileText,
    other: File,
}

/** What to call it to an operator — the vendor's own string is unreadable (`application/vnd.openxml…`). */
export const FILE_KIND_LABEL: Record<AttachmentKind, string> = {
    image: 'Photo',
    audio: 'Audio',
    video: 'Video',
    pdf: 'PDF',
    word: 'Word document',
    spreadsheet: 'Spreadsheet',
    presentation: 'Presentation',
    text: 'Text file',
    other: 'Attachment',
}
